export const shopHeadImage = 'https://file.cnzhizhi.com/common/images/shop-head.png';